import React, {useState} from 'react';
import Avatar from '@material-ui/core/Avatar'
import {useDispatch} from 'react-redux'
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import {userSignOut} from 'actions/Auth';
import IntlMessages from 'util/IntlMessages';
import Divider from "@material-ui/core/Divider";
import { withKeycloak } from '@react-keycloak/web'

const UserInfo = ({ keycloak }) => {

  // const dispatch = useDispatch();

  const [anchorE1, setAnchorE1] = useState(null);
  const [open, setOpen] = useState(false);

  const handleClick = event => {
    setOpen(true);
    setAnchorE1(event.currentTarget);
  };

  const handleRequestClose = () => {
    setOpen(false);
  };

  const handleAccountProfile = () => {
    keycloak.accountManagement();
  };

  const handleLogout = () => {
    keycloak.logout();
  };

  // console.log("PARSED TOKEN: ", keycloak?.tokenParsed);
  const user = (keycloak?.authenticated ?
    {
      name: keycloak?.tokenParsed?.name,
      email: keycloak?.tokenParsed?.email
    } : {
      name: '',
      email: ''
    }
  )
  
  return (
    <div className="user-profile d-flex flex-row align-items-center">
      <Avatar
        alt={(user) ? user.name : ''}
        src={(user) ? user.thumb : ''}
        className="user-avatar"
      />
      <div className="user-detail">
          <h4 className="user-name d-flex" onClick={handleClick}><span className='text-truncate'>{(user) ? user.name : 'Inspector'}</span> 
          <i className="zmdi zmdi-caret-down zmdi-hc-fw align-middle"/>
        </h4>
      </div>
      <Menu className="user-info"
        id="simple-menu"
        anchorEl={anchorE1}
        open={open}
        onClose={handleRequestClose}
        PaperProps={{
          style: {
            minWidth: 120,
            paddingTop: 0,
            paddingBottom: 0
          }
        }}
      >
        <MenuItem onClick={() => { 
            handleRequestClose();
            handleAccountProfile();
          }}>
          <i className="zmdi zmdi-account zmdi-hc-fw mr-2"/>
          <IntlMessages id="popup.profile"/>
        </MenuItem>
        <Divider/>
        <MenuItem onClick={() => {
          handleRequestClose();
          handleLogout();
        }}>
          <i className="zmdi zmdi-sign-in zmdi-hc-fw mr-2"/>
          <IntlMessages id="popup.logout"/>
        </MenuItem>
      </Menu>
    </div>
  );
};

export default withKeycloak(UserInfo);


